import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../../utils/ScrollToTop';
import Loader from '../../hooks/Loader';
import { useLoader } from '../../context/LoaderContext';

const AppLayout: React.FC = () => {
  const { loading } = useLoader();
  return (
    <>
      <div className='flex flex-col min-h-screen'>
        {loading && <Loader />}
        <ScrollToTop />
        <Header />
        <main className='flex-grow'>
          <Outlet />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default AppLayout;
